import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import styled from 'styled-components';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Big from 'UIComponents/elements/Big';
import { H2, H3 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIImage from 'UIComponents/image/UIImage';
import UISection from 'UIComponents/section/UISection';
import { getAssetBusinessTypeI18nKey // @ts-expect-error module is untyped
} from 'ecosystem-marketplace-core/utils/i18n';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import Carousel from 'marketplace-ui-common/components/Carousel'; // @ts-expect-error untype dependency

import growthImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/growth-analytics-icon.svg'; // @ts-expect-error untype dependencys

import homepageImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/homepage-icon.svg';
import { getAllThemeCollectionsRoute, getThemesStorefrontRoute } from '../../utils/urls';
import { useUsedBusinessTypeValues } from '../../hooks/useUsedBusinessTypeValues';
import AssetBusinessTypeUrls from '../../constants/urls/AssetBusinessType';
import StorefrontSection from '../../components/storefront/StorefrontSection';
import ThemeCollectionsCardGrid from '../../storefront/components/ThemeCollectionsCardGrid';
const ASSET_BUSINESS_TYPE_ICON_MAP = {
  ART_ENTERTAINMENT: 'styles',
  CUSTOMER_SERVICE: 'audioInputOutput',
  ECOMMERCE: 'gift',
  EVENT_MANAGEMENT: 'date',
  FINANCIAL_SERVICES: 'salesQuote',
  FOOD_BEVERAGE: 'tag',
  HEALTH_BEAUTY: 'socialHeart',
  HR_RECRUITING: 'lists',
  MARKETING: 'bulb',
  NONPROFIT_EDUCATION: 'cap',
  PROFESSIONAL_SERVICES: 'contactDuplicate',
  REAL_ESTATE: 'key',
  RETAIL: 'cart',
  SMALL_BUSINESS: 'theme',
  TECHNOLOGY: 'desktop',
  TRAVEL_HOSPITALITY: 'language'
};
const StyledUIRouterButton = styled(UIRouterButton).withConfig({
  displayName: "ThemesSection__StyledUIRouterButton",
  componentId: "sc-1eab9c8-0"
})(["display:flex;align-items:stretch;&:hover{color:", " !important;text-decoration:none;}"], EERIE);

function ThemesInnerSection({
  children
}) {
  return /*#__PURE__*/_jsx("div", {
    className: "m-x-12 p-top-15 p-x-10",
    children: children
  });
}

export default function ThemesSection({
  onTrackInteraction
}) {
  const businessTypeValues = useUsedBusinessTypeValues();
  const {
    direction,
    industryWidth,
    maxCardsPerPage,
    width
  } = useResponsiveProps({
    direction: {
      [ScreenSizes.XS]: 'column',
      [ScreenSizes.MD]: 'row'
    },
    industryWidth: {
      [ScreenSizes.XS]: '100px',
      [ScreenSizes.MD]: '130px',
      [ScreenSizes.LG]: '140px'
    },
    maxCardsPerPage: {
      [ScreenSizes.SM]: 2,
      [ScreenSizes.MD]: 3,
      [ScreenSizes.LG]: 5
    },
    width: {
      [ScreenSizes.XS]: undefined,
      [ScreenSizes.MD]: '50%'
    }
  });
  const businessTypeCards = useMemo(() => businessTypeValues.map((businessType, index) => /*#__PURE__*/_jsx(StyledUIRouterButton, {
    className: "p-top-5 m-bottom-5 text-center",
    style: {
      fontWeight: 400,
      height: 85
    },
    to: getThemesStorefrontRoute(AssetBusinessTypeUrls[businessType]),
    use: "unstyled",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "column",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "p-bottom-3",
        name: ASSET_BUSINESS_TYPE_ICON_MAP[businessType],
        size: "medium"
      }), /*#__PURE__*/_jsx("span", {
        style: {
          width: industryWidth
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getAssetBusinessTypeI18nKey(businessType)
        })
      })]
    })
  }, index)), [businessTypeValues, industryWidth]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ThemesInnerSection, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx(H2, {
          className: "text-center is--heading-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.title"
          })
        }), /*#__PURE__*/_jsxs(UIFlex, {
          direction: direction,
          className: "m-right-0  p-all-10",
          justify: "center",
          children: [/*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            className: "m-right-4",
            direction: "column",
            style: {
              width
            },
            children: [/*#__PURE__*/_jsx(UIImage, {
              height: 200,
              responsive: false,
              src: homepageImageUrl
            }), /*#__PURE__*/_jsx(H3, {
              className: "text-center",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.templates.themes.simpleUseTitle"
              })
            }), /*#__PURE__*/_jsx("p", {
              className: "text-center",
              children: /*#__PURE__*/_jsx(Big, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.templates.themes.simpleUseSubtitle"
                })
              })
            })]
          }), /*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            className: "m-left-4",
            direction: "column",
            style: {
              width
            },
            children: [/*#__PURE__*/_jsx(UIImage, {
              height: 200,
              responsive: false,
              src: growthImageUrl
            }), /*#__PURE__*/_jsx(H3, {
              className: "text-center",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.templates.themes.analyticsTitle"
              })
            }), /*#__PURE__*/_jsx("p", {
              className: "text-center",
              children: /*#__PURE__*/_jsx(Big, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.templates.themes.analyticsSubtitle"
                })
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(UIRouterButton, {
          onClick: () => {
            onTrackInteraction('click themes storefront link');
          },
          style: {
            width
          },
          to: getThemesStorefrontRoute(),
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.button"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(ThemesInnerSection, {
      children: [/*#__PURE__*/_jsx(H3, {
        className: "p-bottom-5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.themes.browseByIndustryTitle"
        })
      }), /*#__PURE__*/_jsx(Carousel, {
        cards: businessTypeCards,
        gutterSize: 10,
        maxCardsPerPage: maxCardsPerPage,
        showPagination: false
      })]
    }), /*#__PURE__*/_jsx(ThemesInnerSection, {
      children: /*#__PURE__*/_jsx(StorefrontSection, {
        primaryGridSize: 9,
        subtitle: /*#__PURE__*/_jsx("p", {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(Big, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.themes.themeCollectionsSubtitle"
            })
          })
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.themes.themeCollectionsTitle"
        }),
        titleControls: /*#__PURE__*/_jsx(UIRouterLink, {
          onClick: () => onTrackInteraction('all collections link'),
          to: getAllThemeCollectionsRoute(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.collectionsLink"
          })
        }),
        titleControlsMobile: "md",
        children: /*#__PURE__*/_jsx(UISection, {
          use: "island",
          children: /*#__PURE__*/_jsx(ThemeCollectionsCardGrid, {})
        })
      })
    })]
  });
}